import * as React from "react";
const SvgDotsHorizontal = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.0007 10.0003L10.0007 10.0087M15.0007 10.0003L15.0007 10.0087M5.00065 10.0003L5.00065 10.0087M10.0007 10.8337C9.54041 10.8337 9.16732 10.4606 9.16732 10.0003C9.16732 9.54009 9.54041 9.16699 10.0007 9.16699C10.4609 9.16699 10.834 9.54009 10.834 10.0003C10.834 10.4606 10.4609 10.8337 10.0007 10.8337ZM5.00065 10.8337C4.54041 10.8337 4.16732 10.4606 4.16732 10.0003C4.16732 9.54009 4.54041 9.16699 5.00065 9.16699C5.46089 9.16699 5.83398 9.54009 5.83398 10.0003C5.83398 10.4606 5.46089 10.8337 5.00065 10.8337ZM15.0007 10.8337C14.5404 10.8337 14.1673 10.4606 14.1673 10.0003C14.1673 9.54009 14.5404 9.16699 15.0007 9.16699C15.4609 9.16699 15.834 9.54009 15.834 10.0003C15.834 10.4606 15.4609 10.8337 15.0007 10.8337Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgDotsHorizontal;
